import { type FunctionComponent, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';
import { JiraIcon } from '@trello/nachos/icons/jira';
import { PopoverMenuButton } from '@trello/nachos/popover-menu';
import { NewPill, useNewFeature } from '@trello/new-feature';
import { token } from '@trello/theme';

import styles from './JiraListPopoverMenuButton.less';

interface ListSourcesPopoverProps {
  onClick: () => void;
}

export const JiraListPopoverMenuButton: FunctionComponent<
  ListSourcesPopoverProps
> = ({ onClick }) => {
  const { isNewFeature, acknowledgeNewFeature } =
    useNewFeature('trello-smart-lists');

  const onClickJiraOption = useCallback(() => {
    onClick();
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'menuItem',
      actionSubjectId: 'addFromJiraIssuesMenuItem',
      source: 'listSourcesInlineDialog',
    });
    acknowledgeNewFeature({
      source: 'inlineListComposerJiraListPopoverMenuButton',
    });
  }, [acknowledgeNewFeature, onClick]);

  return (
    <PopoverMenuButton
      onClick={onClickJiraOption}
      iconBefore={
        <JiraIcon color={token('color.icon.accent.blue', '#1D7AFC')} />
      }
    >
      <FormattedMessage
        id="templates.smart_lists.jira-issues"
        defaultMessage="Jira issues"
        description="Product option in the list of products to create a List from"
      />

      {isNewFeature && (
        <div className={styles.textPadding}>
          <NewPill
            featureId="trello-smart-lists"
            source="inlineListComposerInlineDialog"
          />
        </div>
      )}
    </PopoverMenuButton>
  );
};
